const contactDetails = [
  {
    icon: "ri-mail-line",
    label: "Email",
    value: "info@stackmapsystems.com",
    href: "mailto:info@stackmapsystems.com",
  },
  {
    icon: "ri-phone-line",
    label: "Phone (Nigeria)",
    value: "+234 8163 000 0009",
    href: "tel:+23481630000009",
  },
  {
    icon: "ri-phone-line",
    label: "Phone (International)",
    value: "+1 437 424 8823",
    href: "tel:+14374248823",
  },
  {
    icon: "ri-map-pin-line",
    label: "Office",
    value: "15 Kudirat Abiola Way, Oregun, Lagos",
    href: "#",
  },
  {
    icon: "ri-time-line",
    label: "Business Hours",
    value: "Mon-Fri, 9:00 AM-5:00 PM (WAT)",
    href: "#",
  },
];

export default function ContactInfoSection() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-3">
          Reach us directly
        </h2>
        <p className="text-sm md:text-base text-silver-300 leading-relaxed">
          Prefer to call or email? Reach out through any of the channels below and we will respond within one business day.
        </p>
      </div>

      <div className="space-y-4">
        {contactDetails.map((item) => (
          <a
            key={item.label}
            href={item.href}
            className="flex items-start gap-4 group"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-graphite-800 border border-graphite-700 flex-shrink-0 group-hover:border-emerald-accent/30 transition-colors">
              <i className={`${item.icon} text-lg text-emerald-accent`} />
            </div>
            <div>
              <p className="text-sm font-semibold text-white mb-0.5">{item.label}</p>
              <p className="text-sm text-silver-300">{item.value}</p>
            </div>
          </a>
        ))}
      </div>

      <div className="glass-card p-5 rounded-lg bg-emerald-accent/5 border-emerald-accent/10">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-accent/10 shrink-0">
            <i className="ri-lightbulb-line text-emerald-accent" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-1">
              Not sure what you need?
            </h3>
            <p className="text-sm text-silver-300 leading-relaxed">
              Use the Product Advisor to tell us about your challenges and we will recommend the right StackMap configuration.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
